export default "__VITE_ASSET__DctOPivJ__"